module.exports = __webpack_public_path__ + "static/media/linkedin.9d860014.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/linkedin.svg
// module id = 358
// module chunks = 1